<template>
    <div>
        <van-cell-group v-show="!detail">
            <van-cell
                    v-for="(item, index) in showList"
                    :key="index"
                    :title="item.title"
                    :value="item.info"
                    @click="routingTo('knowledge', item)"
            />
        </van-cell-group>
        <div class="show-detail" v-if="detail">
            <h3 class="detail-title">{{detail.title}}</h3>
            <span class="detail-regtime">{{detail.createTime}}</span>
            <hr class="detail-line">
            <div class="detail-content" v-html="detail.content"></div>
        </div>
    </div>
</template>

<script>
    import {Cell, CellGroup} from 'vant';
    import 'vant/lib/cell/style';
    import 'vant/lib/cell-group/style';

    export default {
        name: 'serviceGuide',
        components: {
            vanCellGroup: CellGroup,
            vanCell: Cell
        },
        mounted(){

        },
        data(){
            return {
                strucid: '3',
                dataList: [],
                showList: [],
                contentItem: '', //要展示的内容
                argid: '',
                leafDoc: '',
                detail: null
            }
        },
        watch: {
            '$route' (to, from) {
                if(to.query.id){
                    this.argid = to.query.id;
                    this.leafDoc = to.query.leaf_doc ? to.query.leaf_doc : '0';
                } else {
                    this.argid = '$$$$$$$$';
                }
                this.changeShowList(this.argid);
                //this.getData(); // 每次都刷新
            }
        },
        created(){
            this.getData();
        },
        methods: {
            getData(){
                let self = this;
                self.$http.post('/miapp/A1201/mpaasgatewayunencrypted', {
                    buztype: 5752,
                    strucid: self.strucid
                }).then(res => {
                    self.$utils.loading(false);
                    res = typeof res === 'string' ? JSON.parse(res) : res;
                    if(res.recode === '000000' || res.message === 'success'){
                        self.dataList = res.data;
                        //self.changeShowList(self.argid); // 每次都刷新
                        self.changeShowList('');
                    } else {
                        self.$utils.alert(res.msg, function(){
                            self.$router.go(-1);
                        });
                    }
                }).catch(res => {
                    self.$utils.loading(false);
                    console.log("error", res);
                });
            },
            changeShowList(argid){
                let self = this;
                argid = argid === '' ? '$$$$$$$$' : argid;
                if(self.leafDoc !== '1'){
                    self.showList = [];
                    self.detail = null;
                    self.dataList.filter((item, index) => {
                        if(item.pid === argid){
                            self.showList.push(item);
                        }
                    });
                }
                console.log(self.leafDoc);
                console.log(self.argid);
                if(self.leafDoc === '1') {
                    self.detail = self.dataList.filter((item, index) => {
                        return item.id === self.argid;
                    })[0];
                }
            },
            routingTo(target, item){
                let self = this;
                self.$router.push({
                    path: '/' + target,
                    query: {
                        'openweb': 'paschybrid',
                        'id': item.id,
                        'leaf_doc': item.leaf_doc,
                    }
                });
            }
        }
    }
</script>

<style>
    body {background:#e5e5e5;}
</style>
<style lang="stylus" scoped>
    .van-cell__title
        font-size .32rem
    .van-cell__label
        font-size .3rem
    .van-cell
        align-items center
    .van-cell:not(:last-child)::after
        left 0
    .van-cell__right-icon
        color #518ede
    .show-detail
        min-height 100%
        background #fff
        .detail-title
            font-size .42rem
            line-height .6rem
            color #333
            font-weight 400
            padding .3rem .3rem 0
            word-break  break-all
        .detail-regtime
            font-size .3rem
            line-height .4rem
            display block
            padding .1rem .3rem .14rem
            color #999
            word-break  break-all
        .detail-line
            height 0px
            display block
            border-bottom solid 1px #999
            margin .1rem 0
            border-top none
            border-right none
            border-left none
            box-shadow none
        .detail-content
            padding .2rem .3rem
            word-break break-all
</style>